import { apiSecond } from '@/boot/axios'

export default {
	namespaced: true,
	state: {
		selectedFishingYear: {
			label: '01.01.2026 - 31.12.2026',
			start: '2026-01-01',
			finish: '2026-12-31',
		},
		dashboardData: null,
		fishesData: null,
		loading: false,
		error: null,
	},
	mutations: {
		SET_SELECTED_FISHING_YEAR(state, fishingYear) {
			state.selectedFishingYear = fishingYear
		},
		SET_DASHBOARD_DATA(state, data) {
			state.dashboardData = data
		},
		SET_FISHES_DATA(state, data) {
			state.fishesData = data
		},
		SET_LOADING(state, loading) {
			state.loading = loading
		},
		SET_ERROR(state, error) {
			state.error = error
		},
	},
	actions: {
		async setFishingYear({ commit, dispatch }, { fishingYear, userTag }) {
			commit('SET_SELECTED_FISHING_YEAR', fishingYear)
			// Refresh dashboard data with new dates
			await dispatch('fetchDashboardData', userTag)
			await dispatch('fetchFishesData', userTag)
		},
		async fetchDashboardData({ commit, state }, userTag) {
			try {
				commit('SET_LOADING', true)
				commit('SET_ERROR', null)

				const params = {
					date_from: state.selectedFishingYear.start,
					date_to: state.selectedFishingYear.finish,
				}

				const response = await apiSecond.get(`v1/dashboard/${userTag}/1`, { params })

				// Always set data, even if null or empty, so components can show empty states
				if (response?.data?.data) {
					commit('SET_DASHBOARD_DATA', response.data.data)
				} else {
					// Set default empty data structure
					commit('SET_DASHBOARD_DATA', {
						sum_total_fish_quota: 0,
						sum_total_fish_permission: 0,
						sum_total_fish_trade: 0,
						percentage_quota_permission: 0,
						percentage_trade_permission: 0,
					})
				}
			} catch (error) {
				console.error('Error fetching dashboard data:', error)
				commit('SET_ERROR', error.message || 'Ошибка загрузки данных')
				// Set default empty data structure on error too
				commit('SET_DASHBOARD_DATA', {
					sum_total_fish_quota: 0,
					sum_total_fish_permission: 0,
					sum_total_fish_trade: 0,
					percentage_quota_permission: 0,
					percentage_trade_permission: 0,
				})
			} finally {
				commit('SET_LOADING', false)
			}
		},
		async fetchFishesData({ commit, state }, userTag) {
			try {
				commit('SET_LOADING', true)
				commit('SET_ERROR', null)

				const params = {
					date_from: state.selectedFishingYear.start,
					date_to: state.selectedFishingYear.finish,
				}

				const response = await apiSecond.get(`v1/dashboard/${userTag}/fishes`, { params })

				// Always set data, even if null or empty, so components can show empty states
				if (response?.data) {
					commit('SET_FISHES_DATA', response.data)
				} else {
					// Set default empty data structure
					commit('SET_FISHES_DATA', {
						data: [],
						total_value: 0,
					})
				}
			} catch (error) {
				console.error('Error fetching fishes data:', error)
				commit('SET_ERROR', error.message || 'Ошибка загрузки данных')
				// Set default empty data structure on error too
				commit('SET_FISHES_DATA', {
					data: [],
					total_value: 0,
				})
			} finally {
				commit('SET_LOADING', false)
			}
		},
		async initializeDashboard({ dispatch }, userTag) {
			await dispatch('fetchDashboardData', userTag)
			await dispatch('fetchFishesData', userTag)
		},
	},
	getters: {
		getSelectedFishingYear: (state) => state.selectedFishingYear,
		getDashboardData: (state) => state.dashboardData,
		getFishesData: (state) => state.fishesData,
		isLoading: (state) => state.loading,
		getError: (state) => state.error,
	},
}
